(function() {
  const PERSONALIZATION_VARIANT_ID = 42456033591392;
  const originalFetch = window.fetch;

  window.fetch = function(...args) {
    const [resource, options] = args;

    if (typeof resource === 'string' && resource.includes('/cart/add')) {
      let body = options && options.body;

      if (body instanceof FormData) {
        const customValue = body.get('properties[Preferred Name & Number]');
        if (customValue) {
          setTimeout(() => addCartItem(PERSONALIZATION_VARIANT_ID, 1), 0);
        }
      }

      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          return fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              syncPersonalizationAddOn(cart);
              return response;
            });
        }
        return response;
      });
    }

    if (typeof resource === 'string' && resource.includes('/cart/change')) {
      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          return fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              syncPersonalizationAddOn(cart);
              return response;
            });
        }
        return response;
      });
    }

    return originalFetch.apply(this, args);
  };

  function syncPersonalizationAddOn(cartData) {
    let totalCustomItems = 0;

    cartData.items.forEach(item => {
      if (item.properties && item.properties['Preferred Name & Number']) {
        totalCustomItems += item.quantity;
      }
    });

    const addOnItem = cartData.items.find(item => item.variant_id === PERSONALIZATION_VARIANT_ID);

    if (totalCustomItems > 0) {
      if (addOnItem) {
        if (addOnItem.quantity !== totalCustomItems) {
          updateCartItem(addOnItem.key, totalCustomItems);
        }
      } else {
        addCartItem(PERSONALIZATION_VARIANT_ID, totalCustomItems);
      }
    } else if (addOnItem) {
      updateCartItem(addOnItem.key, 0);
    }

    const input = document.querySelector(`.quantity__input[data-quantity-variant-id="${PERSONALIZATION_VARIANT_ID}"]`);
    if (input) input.value = totalCustomItems;
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }

  function addCartItem(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => syncPersonalizationAddOn(cart));
})();